import React from 'react';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonCard,
  IonCardContent,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  useIonViewWillLeave,
} from '@ionic/react';
import {
  mailOutline,
  documentTextOutline,
  shieldCheckmarkOutline,
  sparklesOutline,
} from 'ionicons/icons';
import SnowballMenu from '@/modules/user/SnowballMenu';

const About: React.FC = () => {
  useIonViewWillLeave(() => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  });

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/topics" />
          </IonButtons>
          <IonTitle>About Snowball</IonTitle>
          <IonButtons slot="end">
            <SnowballMenu />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div>
          <div
            style={{
              padding: '16px 16px 0',
              fontSize: '0.9rem',
              lineHeight: 1.5,
            }}
          >
            <p style={{ marginTop: 0, marginBottom: '1.4em' }}>
              A few years ago, I formed a local initiative after a neighborhood
              tragedy. It grew into a healing celebration with thousands of
              participants — despite a meager mailing list and a limited social
              media campaign. The secret was word of mouth, and ever since I’ve
              wanted to harness that organic virality for spontaneous community
              organizing.
            </p>
            <p style={{ marginTop: 0, marginBottom: '1.4em' }}>
              The result is Snowball, a "lowest common motivator" app that
              spreads the word using plain old text messaging. It’s simple but
              privacy-centric, with guardrails to keep it from becoming just
              another spammy social media outlet. It draws on my decades in
              software engineering, including more than 10 years at Google and my
              current role leading trust-and-safety engineering for an education
              non-profit.
            </p>
            <p style={{ marginTop: 0, marginBottom: '1.4em' }}>
              This is a nights-and-weekends project, so expect some rough edges.
              But with your feedback, I hope we can make it a tool that unlocks
              your ideas for community action. I'm excited to see what you do
              with it!
            </p>
            <p style={{ margin: 0 }}>—Chris</p>
          </div>

          <IonCard>
            <IonCardContent>
              <IonList inset={false}>
                <IonItem
                  button
                  detail
                  routerLink="/contact"
                  lines="full"
                  data-testid="about-contact-item"
                >
                  <IonIcon icon={mailOutline} slot="start" />
                  <IonLabel>Contact us</IonLabel>
                </IonItem>
                <IonItem
                  href="/tos"
                  detail
                  lines="full"
                  data-testid="about-terms-item"
                >
                  <IonIcon icon={documentTextOutline} slot="start" />
                  <IonLabel>Terms of Service</IonLabel>
                </IonItem>
                <IonItem
                  href="/privacy"
                  detail
                  lines="full"
                  data-testid="about-privacy-item"
                >
                  <IonIcon icon={shieldCheckmarkOutline} slot="start" />
                  <IonLabel>Privacy Policy</IonLabel>
                </IonItem>
                <IonItem
                  href="/release-notes"
                  detail
                  lines="none"
                  data-testid="about-release-notes-item"
                >
                  <IonIcon icon={sparklesOutline} slot="start" />
                  <IonLabel>Release Notes</IonLabel>
                </IonItem>
              </IonList>
            </IonCardContent>
          </IonCard>

          <p
            style={{
              textAlign: 'center',
              color: 'var(--ion-color-medium)',
              fontSize: '0.8rem',
            }}
          >
            &copy; {new Date().getFullYear()} Kick Turn Solutions LLC
          </p>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default About;
